export function defineGraphqlConfig(config) {
  if (!isCallable(config)) {
    return () => config;
  }
  return config;
}
function isCallable(fn) {
  return fn instanceof Function;
}
